exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".side-nav-override {\n    box-shadow: 6px 0px 0px 0px #ccc;\n}\n\n.container-override {\n    position: relative !important;\n}\n\n.start-content-padding {\n    padding: 0px !important;\n    background-color: white;\n    overflow-y: hidden !important;\n}\n\n.content-area-override {\n    padding: 36px !important;\n    padding-right: 21px !important;\n}\n\n\n/*.global-message-alert {\n    position: fixed;\n    top: 55px;\n    left: 260px;\n    width: 100%;\n    z-index: 999;\n    padding-right: 276px;\n}*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/base/harbor-shell/harbor-shell.component.css
// module id = 812
// module chunks = 0